import { Component, h, Prop } from '@stencil/core';
import arrow from '../../assets/header/next_arrow.svg';
import account from '../../assets/header/account.svg';
import cart from '../../assets/header/cart_grey.svg';
import locationPin from '../../assets/header/stores_pin.svg';
import printfectionLogo from '../../assets/header/printfection.svg';
import redPhone from '../../assets/phone_red.svg';


@Component({
  tag: 'ci-mobile-subnav',
  styleUrl: 'ci-mobile-subnav.scss',
})
export class ciMobileSubnav {
  @Prop() serviceNumber: string;

  render() {
    const productSubNavClick = () => {
      const productsMenu = document.getElementById('cdMobileSubNav-productsMenu');
      const rotatedArrow = document.getElementById('rotate-arrow-product');

      productsMenu.classList.toggle('ciMobileSubnav-products-menu-wrapper--active');
      rotatedArrow.classList.toggle('ciMobileSubnav-products-arrow--active');
    };
    const solutionsSubNavClick = () => {
      const productsMenu = document.getElementById('cdMobileSubNav-solutionsMenu');
      const rotatedArrow = document.getElementById('rotate-arrow-solutions');

      productsMenu.classList.toggle('ciMobileSubnav-solutions-menu-wrapper--active');
      rotatedArrow.classList.toggle('ciMobileSubnav-solutions-arrow--active');
    };
    return (
      <div class="ciMobileSubnav">
        <ci-drawer>
          <ul class="ciMobileSubnav-mainMenu">
            <li class="ciMobileSubnav-mainMenu-listItem">
              <a class="ciMobileSubnav-mainMenu-link" onClick={productSubNavClick}>
                Products
                <img class="ciMobileSubnav-products-arrow" id="rotate-arrow-product" src={arrow} alt="arrow icon" />
              </a>
            </li>
            <div class="ciMobileSubnav-products-menu-wrapper" id="cdMobileSubNav-productsMenu">
              <ul class="ciMobileSubnav-products-menu" id="products">
                <li class="ciMobileSubnav-products-menu-listItem">
                  <a href={`${process.env.CI_HOSTNAME}/products/t-shirts/4`}
                  class="ciMobileSubnav-products-menu-link js-ciHeader-track"
                  data-section="products"
                  data-link="t-shirts">
                    <span>T-shirts</span>
                  </a>
                </li>
                <li class="ciMobileSubnav-products-menu-listItem">
                  <a href={`${process.env.CI_HOSTNAME}/products/sweatshirts/hoodies/71`}
                  class="ciMobileSubnav-products-menu-link js-ciHeader-track"
                  data-section="products"
                  data-link="hoodies">
                    <span>Hoodies</span>
                  </a>
                </li>
                <li class="ciMobileSubnav-products-menu-listItem">
                  <a href={`${process.env.CI_HOSTNAME}/products/sweatshirts/13`}
                  class="ciMobileSubnav-products-menu-link js-ciHeader-track"
                  data-section="products"
                  data-link="sweatshirts">
                    <span>Sweatshirts</span>
                  </a>
                </li>
                <li class="ciMobileSubnav-products-menu-listItem">
                  <a href={`${process.env.CI_HOSTNAME}/products/polo-shirts/148`}
                  class="ciMobileSubnav-products-menu-link js-ciHeader-track"
                  data-section="products"
                  data-link="polo shirts">
                    <span>Polo Shirts</span>
                  </a>
                </li>
                <li class="ciMobileSubnav-products-menu-listItem">
                  <a href={`${process.env.CI_HOSTNAME}/products/hats/1`}
                  class="ciMobileSubnav-products-menu-link js-ciHeader-track"
                  data-section="products"
                  data-link="hats">
                    <span>Hats</span>
                  </a>
                </li>
                <li class="ciMobileSubnav-products-menu-listItem">
                  <a href={`${process.env.CI_HOSTNAME}/products/promotional-products/218`}
                  class="ciMobileSubnav-products-menu-link js-ciHeader-track"
                  data-section="products"
                  data-link="promotional products">
                    <span>Promotional Products</span>
                  </a>
                </li>
                <li class="ciMobileSubnav-products-menu-listItem">
                  <a href={`${process.env.CI_HOSTNAME}/products`}
                  class="ciMobileSubnav-products-menu-link js-ciHeader-track"
                  data-section="products"
                  data-link="view all categories">
                    <span>View All Categories</span>
                  </a>
                </li>
              </ul>
            </div>
            <li class="ciMobileSubnav-mainMenu-listItem">
              <a href={`${process.env.CI_HOSTNAME}/lab`}
              class="ciMobileSubnav-mainMenu-link js-ciHeader-track"
              data-section="design lab"
              data-link="design lab">
                Design Lab
              </a>
            </li>
            <li class="ciMobileSubnav-mainMenu-listItem">
              <a href={`${process.env.CI_HOSTNAME}/inspiration`}
              class="ciMobileSubnav-mainMenu-link js-ciHeader-track"
              data-section="templates"
              data-link="templates">
                Templates
              </a>
            </li>
            <li class="ciMobileSubnav-mainMenu-listItem">
              <a class="ciMobileSubnav-mainMenu-link"
              onClick={solutionsSubNavClick}>
                Solutions
                <img class="ciMobileSubnav-solutions-arrow" id="rotate-arrow-solutions" src={arrow} alt="arrow icon" />
              </a>
            </li>
            <div class="ciMobileSubnav-solutions-menu-wrapper" id="cdMobileSubNav-solutionsMenu">
              <ul class="ciMobileSubnav-solutions-menu" id="solutions">
                <li class="ciMobileSubnav-solutions-menu-listItem">
                  <span data-href={`${process.env.CI_HOSTNAME}/ink/group-order-form`}
                  class="ciMobileSubnav-solutions-menu-linkSolutions js-menu-span-link js-ciHeader-track"
                  data-section="solutions"
                  data-link="Group Order">
                    <span class="ciMobileSubnav-solutions-menu-linkSolutions-title">
                      Group Order
                    </span>
                    <span class="ciMobileSubnav-solutions-menu-linkSolutions-subtitle">
                      Easily collect sizes, addresses, and payments from your group.
                    </span>
                  </span>
                </li>
                <li class="ciMobileSubnav-solutions-menu-listItem">
                  <span data-href={`${process.env.CI_HOSTNAME}/inventory-distribution`}
                  class="ciMobileSubnav-solutions-menu-linkSolutions js-menu-span-link js-ciHeader-track"
                  data-section="solutions"
                  data-link="Inventory & Distribution">
                    <span class="ciMobileSubnav-solutions-menu-linkSolutions-title">
                      Inventory & Distribution
                    </span>
                    <span class="ciMobileSubnav-solutions-menu-linkSolutions-subtitle">
                      Store and send branded swag anywhere. Think of us as your online supply closet!
                    </span>
                  </span>
                </li>
                <li class="ciMobileSubnav-solutions-menu-listItem">
                  <span data-href={`${process.env.CI_HOSTNAME}/fundraising`}
                  class="ciMobileSubnav-solutions-menu-linkSolutions js-menu-span-link js-ciHeader-track"
                  data-section="solutions"
                  data-link="Fundraising">
                    <span class="ciMobileSubnav-solutions-menu-linkSolutions-title">
                      Fundraising
                    </span>
                    <span class="ciMobileSubnav-solutions-menu-linkSolutions-subtitle">
                      Raise money and awareness for anything you care about.
                    </span>
                  </span>
                </li>
                <li class="ciMobileSubnav-solutions-menu-listItem">
                  <span data-href={`${process.env.CI_HOSTNAME}/onlinestores`}
                  class="ciMobileSubnav-solutions-menu-linkSolutions js-menu-span-link js-ciHeader-track"
                  data-section="solutions"
                  data-link="Online Stores">
                    <span class="ciMobileSubnav-solutions-menu-linkSolutions-title">
                      Online Stores
                    </span>
                    <span class="ciMobileSubnav-solutions-menu-linkSolutions-subtitle">
                      Create a branded storefront to sell merchandise to your community.
                    </span>
                  </span>
                </li>
                <li class="ciMobileSubnav-solutions-menu-listItem">
                  <span data-href="https://www.printfection.com"
                  class="ciMobileSubnav-solutions-menu-linkSolutions js-menu-span-link js-ciHeader-track"
                  data-section="solutions"
                  data-link="Printfection">
                    <span class="ciMobileSubnav-solutions-menu-linkSolutions-image">
                      <img class="ciMobileSubnav-solutions-menu-linkSolutions-printfection" src={printfectionLogo} alt="Printfection" />
                    </span>
                    <span class="ciMobileSubnav-solutions-menu-linkSolutions-subtitle">
                      In need of custom kits, detailed reporting on swag usage, white-glove customer service, and global shipping? Check out our swag management solution made for Enterprise businesses.﻿
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </ul>
          <ul class="ciMobileSubnav-secondaryMenu">
            <li class="ciMobileSubnav-secondaryMenu-listItem">
              <a class="ciMobileSubnav-secondaryMenu-link js-ciHeader-track"
              href={`${process.env.CI_HOSTNAME}/profiles/retrieve`}
              data-section="my account"
              data-link="my account">
                <img src={account} alt="account icon" />
                My Account
              </a>
            </li>
            <li class="ciMobileSubnav-secondaryMenu-listItem">
              <a class="ciMobileSubnav-secondaryMenu-link js-ciHeader-track"
              href={`${process.env.CI_HOSTNAME}/checkout/summary`}
              data-section="my cart"
              data-link="my cart">
                <img src={cart} alt="cart icon" />
                My Cart
              </a>
            </li>
            <li class="ciMobileSubnav-secondaryMenu-listItem">
              <a class="ciMobileSubnav-secondaryMenu-link"
              href="https://locations.customink.com/">
                <img src={locationPin} alt="stores pin icon" />
                Visit a Store
              </a>
            </li>
          </ul>
          <div class="ciMobileSubnav-chat">
            <a href={`tel:${this.serviceNumber}`}
            class="tertiary-secondary-button">
              <img class="ciMobileSubnav-headset" src={redPhone} alt="headset icon" />
              <span class="ciMobileSubnav-real-person">Talk to a Real Person</span>
            </a>
          </div>
        </ci-drawer>
      </div>
    );
  }
}
